import {
  IUpdateCarrierReferences,
  ICarrierApplication,
  ISubmitBrokerCarrierAgreementPayload,
  ISubmitCarrierPackageFiles,
  IReference,
  ICarrierPackageFile,
} from 'types'
import callApi, { ENDPOINTS } from 'utils/api/callApi'

/**
 * Fetches a carrier application by id
 * @method GET
 */
export const fetchMarketplaceCarrierApplication = (
  id: string
): Promise<{
  carrierApplication: ICarrierApplication
}> => {
  return callApi({
    method: 'GET',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    id,
  })
}

/**
 * Submit broker carrier agreement
 * @method POST
 */
export const submitBrokerCarrierAgreement = (
  id: string,
  payload: ISubmitBrokerCarrierAgreementPayload
): Promise<ICarrierApplication> => {
  const { brokerCarrierAgreement, carrierApplication } = payload || {}
  return callApi({
    method: 'POST',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    group: 'broker_carrier_agreements',
    body: {
      brokerCarrierAgreement,
      carrierApplication,
    },
    id,
  })
}

/**
 * Submit carrier package files
 * @method POST
 */
export const submitCarrierPackageFiles = (
  id: string,
  files: ISubmitCarrierPackageFiles
): Promise<{
  packageFiles: ICarrierPackageFile[]
}> => {
  const { packageFiles } = files || {}
  return callApi({
    method: 'POST',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    group: 'package_files',
    body: {
      packageFiles,
    },
    id,
  })
}

/**
 * Add Carrier References
 * @method POST
 */
export const updateCarrierReferences = (
  id: string,
  references: IUpdateCarrierReferences
): Promise<{
  carrierReferences: IReference[]
}> => {
  const { carrierReferences } = references || {}
  return callApi({
    method: 'POST',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    group: 'carrier_references',
    body: {
      carrierReferences,
    },
    id,
  })
}

/**
 * Sends carrier packet email?
 * @method PUT
 */
export const sendCarrierPacketEmail = (
  id: string
): Promise<{
  carrierApplication: ICarrierApplication
}> => {
  return callApi({
    method: 'PUT',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    group: 'request_send_packet',
    id,
  })
}

/**
 * Sends document review email?
 * @method PUT
 */
export const sendDocumentReviewEmail = (
  id: string
): Promise<{
  carrierApplication: ICarrierApplication
}> => {
  return callApi({
    method: 'PUT',
    endpoint: ENDPOINTS.fleetPlannerCarriers,
    group: 'send_document_reviewing_email',
    id,
  })
}
